<template>
    <div class="chartitem">
        <!-- 触发弹窗的按钮 -->
        <van-button type="primary" @click="showDatePicker = true">选择年月</van-button>

        <!-- 弹窗 -->
        <van-dialog v-model="showDatePicker" title="选择年月" :show-cancel-button="false" @confirm="confirmDate"
            @cancel="showDatePicker = false" :show-confirm-button="false">
            <!-- 时间选择器 -->
            <van-datetime-picker v-model="currentDate" type="year-month" :min-date="minDate" :max-date="maxDate"
                :formatter="formatter" @confirm="confirmDate" @cancel="showDatePicker = false" />
        </van-dialog>

        <!-- 显示选中的年月 -->
        <div class="nytxt" v-if="selectedYearMonth">
            您选择的年月是：{{ selectedYearMonth }}
        </div>

    </div>
</template>

<script>


export default {

    props: {
        chartData: {
            type: Array,
        },
    },

    data() {
        return {
            showDatePicker: false, // 控制弹窗显示与隐藏  
            currentDate: new Date(), // 时间选择器的当前值  
            selectedYearMonth: '', // 存储选中的年月  
            minDate: new Date(1900, 0, 1), // 最小日期  
            maxDate: new Date(2099, 11, 31), // 最大日期  
        };
    },
    mounted() {

    },
    methods: {
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`
            }
            return val;
        },
        confirmDate(value) {
            // console.log(value);
            // 当时间选择器确认时触发  
            this.selectedYearMonth = `${value.getFullYear()}-${value.getMonth() + 1}`;
            this.showDatePicker = false; // 关闭弹窗  
            this.$emit('changeda', this.selectedYearMonth);
        },
    },
    watch: {
        chartData: {
            handler() {

            },
            deep: true,
        },
    },
};
</script>
<style lang="less" scoped>
.chartitem {
    width: 100%;
    height: 100%;

    .nytxt {
        margin: 2vh 0 2vh 0;
    }
}
</style>